<div class="modal-layer" [ngClass]="{ 'active':modal.open }">
    <div class="backdrop"></div>
    <div class="alert" *ngIf="modal.cntx == 'loading'">
      <div class="loader">
          <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
          <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
      </div>
      <span class="loader-text">Зареждане на карта...</span>
    </div>
    <div class="alert" *ngIf="modal.cntx == 'editting-warranty'">
        <div class="loader">
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
        </div>
        <span class="loader-text">Променяне на гаранционна карта...</span>
    </div>
  </div>

<div class="content no-subheader warranty-form">
    <div class="wf-header">
        <div class="wf-title">
            <span class="wf-title-main">Промяна на гаранционна карта <span class="wf-title-id" *ngIf="editWarranty.warranty_id">№ {{ editWarranty.warranty_id }}</span></span>
            <span class="wf-title-sub">Полетата със <span class="wf-required">*</span> са задължителни</span>
        </div>
        <div class="wf-actions">
            <span class="wf-missing" *ngIf="!returnIsValid()">Попълнете: {{ returnMissingFields().join(', ') }}</span>
            <span routerLink="/warranties" class="wf-btn wf-btn-secondary">Отказ</span>
            <a class="wf-btn wf-btn-primary" [ngClass]="{ 'disabled':!returnIsValid() }" (click)="EditWarranty()">Запис</a>
        </div>
    </div>

    <div class="wf-notice">
        <div class="wf-notice-main">
            <div class="wf-notice-badge">!</div>
            <div class="wf-notice-text">
                <div class="wf-notice-lead"><strong>Важно:</strong> Гаранционна карта може да съдържа артикули само от една марка. За артикули от друга марка създайте отделна гаранционна карта.</div>
            </div>
        </div>
        <div class="wf-notice-secondary">
            <span>При регистрация на климатици <strong>Fuji Electric</strong> въвеждайте серийния номер, като изпишете модела на тялото пред него, тъй като различни модели климатици могат да имат еднакви серийни номера.</span>
            <ul>
                <li>Вътрешно тяло <strong>RSG12LMCA</strong> с номер <strong>Е000123</strong> → въведете <strong>RSG12LMCAE000123</strong></li>
                <li>Външно тяло <strong>ROG12LMCA</strong> с номер <strong>Е000456</strong> → въведете <strong>ROG12LMCAE000456</strong></li>
            </ul>
        </div>
    </div>

    <div class="tab-holder wf-tabs">
        <div class="tab-headers">
            <div class="tab-header" (click)="switchTab('general')" [ngClass]="{ 'active':tab == 'general' }">Основна информация</div>
            <div class="tab-header" (click)="switchTab('warranty_text')" *ngIf="system.returnIsAdmin() || system.returnRole() == 3" [ngClass]="{ 'active':tab == 'warranty_text' }">Гаранционни условия</div>
            <div class="tab-header" (click)="switchTab('products')"  [ngClass]="{ 'active':tab == 'products' }">Артикули<span class="count-badge">{{ returnTotalProducts() }}</span></div>
            <div class="tab-header" (click)="switchTab('warranty_time')" *ngIf="returnTotalProducts() > 0 && system.returnRole() == 3 || returnTotalProducts() > 0 && system.returnRole() == 1"  [ngClass]="{ 'active':tab == 'warranty_time' }">Гаранционни сроци</div>
        </div>
        <div class="tab-content">
            <div class="tab" *ngIf="tab == 'general'">
                <div class="wf-grid">
                    <div class="wf-card">
                        <div class="wf-card-title">Информация за клиент</div>
                        <div class="wf-fields">
                            <div class="input-row wf-span-2">
                                <span class="label">Име на клиент <span class="wf-required">*</span></span>
                                <input type="text" placeholder="Въведете име на клиент" [ngClass]="{ 'error-field':editWarranty.client_name.length < 1 }" (focus)="selectingClient = true" (focusout)="deselectClient()" [(ngModel)]="editWarranty.client_name" (keyup)="searchClient()" />
                                <div class="dropdown-list" *ngIf="selectingClient && editWarranty.client_name.length > 3">
                                    <span *ngFor="let client of clientsSearches" (click)="selectClient(client)">{{ client.name }}</span>
                                </div>
                            </div>
                            <div class="input-row">
                                <span class="label">Телефон на клиент</span>
                                <input type="text" placeholder="Въведете телефон на клиент" [(ngModel)]="editWarranty.client_phone" />
                            </div>
                            <div class="input-row">
                                <span class="label">Имейл</span>
                                <input type="text" placeholder="Въведете имейл" [ngClass]="{ 'error-field':editWarranty.client_email && editWarranty.client_email.length > 0 && !returnValidateEmail(editWarranty.client_email) }" [(ngModel)]="editWarranty.client_email" />
                            </div>
                            <div class="input-row">
                                <span class="label">Адрес на монтаж <span class="wf-required">*</span></span>
                                <input type="text" placeholder="Въведете адрес на монтаж" [ngClass]="{ 'error-field':editWarranty.client_address.length < 1 }" [(ngModel)]="editWarranty.client_address" />
                            </div>
                            <div class="input-row">
                                <span class="label">Населено място</span>
                                <input type="text" placeholder="Започнете да пишете..." [(ngModel)]="editWarranty.town" (focus)="selectingTown = true" (focusout)="deselectTown()" />
                                <div class="dropdown-list" *ngIf="selectingTown && editWarranty.town.length > 0">
                                    <span *ngFor="let town of returnFilteredTown()" (click)="selectTown(town)">{{ town.name }}</span>
                                </div>
                            </div>
                            <div class="input-row">
                                <div id="delivery-date-picker" class="date-picker" [ngClass]="{ 'active':purchase_date_picker }" (clickOutside)="purchase_date_picker = false">
                                    <div class="datepicker-header">
                                        <div class="datepicker-left-tool hoverable" (click)="prevPurchaseMonth()"><i class='icon arrow-left'></i></div>
                                        <span class="datepicker-title" id="date_delivery_title">{{ returnMonthName(returnMonth(current_purchase_date)) }} {{ returnYear(current_purchase_date) }}</span>
                                        <div class="datepicker-right-tool hoverable" (click)="nextPurchaseMonth()"><i class='icon arrow-right'></i></div>
                                    </div>
                                    <div class="datepicker-content">
                                        <div class="datepicker-title-row">
                                            <span>Пн</span><span>Вт</span><span>Ср</span><span>Чт</span><span>Пт</span><span>Сб</span><span>Нд</span>
                                        </div>
                                        <div class="datepicker-row" id="date_delivery_body">
                                            <span *ngFor="let dt of current_purchase_month_dates" [ngClass]="{ 'disabled':!dt.active, 'selected':dt.date == returnDate(current_purchase_date) && dt.month == returnMonth(editWarranty.date_purchase) - 1 }" (click)="selectPurchaseDate(dt)">{{ dt.date }}</span>
                                        </div>
                                    </div>
                                </div>
                                <span class="label">Дата на закупуване</span>
                                <input type="text" class="wf-date-input" placeholder="Изберете дата" readonly value="{{ returnDateFormated(editWarranty.date_purchase) }}" (click)="openPurchasePicker()"  />
                            </div>
                            <div class="input-row">
                                <div id="delivery-date-picker" class="date-picker" [ngClass]="{ 'active':installation_date_picker }" (clickOutside)="installation_date_picker = false">
                                    <div class="datepicker-header">
                                        <div class="datepicker-left-tool hoverable" (click)="prevInstallationMonth()"><i class='icon arrow-left'></i></div>
                                        <span class="datepicker-title" id="date_delivery_title">{{ returnMonthName(returnMonth(current_installation_date)) }} {{ returnYear(current_installation_date) }}</span>
                                        <div class="datepicker-right-tool hoverable" (click)="nextInstallationMonth()"><i class='icon arrow-right'></i></div>
                                    </div>
                                    <div class="datepicker-content">
                                        <div class="datepicker-title-row">
                                            <span>Пн</span><span>Вт</span><span>Ср</span><span>Чт</span><span>Пт</span><span>Сб</span><span>Нд</span>
                                        </div>
                                        <div class="datepicker-row" id="date_delivery_body">
                                            <span *ngFor="let dt of current_purchase_month_dates" [ngClass]="{ 'disabled':!dt.active, 'selected':dt.date == returnDate(current_installation_date) && dt.month == returnMonth(editWarranty.date_installation) - 1 }" (click)="selectInstallationDate(dt)">{{ dt.date }}</span>
                                        </div>
                                    </div>
                                </div>
                                <span class="label">Дата на монтаж</span>
                                <input type="text" class="wf-date-input" placeholder="Изберете дата"  readonly value="{{ returnDateFormated(editWarranty.date_installation) }}" (click)="openInstallationPicker()"  />
                            </div>
                        </div>
                    </div>

                    <div class="wf-card">
                        <div class="wf-card-title">Сервизна информация</div>
                        <div class="wf-fields">
                            <div class="input-row wf-span-2">
                                <span class="label">Техническо лице</span>
                                <input type="text" placeholder="Въведете техническо лице"  [(ngModel)]="editWarranty.technician" />
                            </div>
                            <div class="input-row">
                                <span class="label">Адрес на сервиз</span>
                                <input type="text" placeholder="Въведете адрес на сервиз"  [(ngModel)]="editWarranty.service_address" />
                            </div>
                            <div class="input-row">
                                <span class="label">Телефон на сервиз</span>
                                <input type="text" placeholder="Въведете телефон на сервиз" [(ngModel)]="editWarranty.service_phone" />
                            </div>
                            <div class="wf-span-2" *ngIf="system.returnRole() == 3 || system.returnIsAdmin()">
                                <label class="container modal-row">Търг - Димитровград 2026
                                    <input type="checkbox" checked="checked" [(ngModel)]="editWarranty.tender_dimitrovgrad">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wf-step-footer">
                    <span class="wf-btn wf-btn-primary" (click)="switchTab('products')">Напред към артикули →</span>
                </div>
            </div>

            <div class="tab" *ngIf="tab == 'products'">
                <div class="wf-products-bar">
                    <div class="wf-products-info">
                        <strong>Артикули</strong>
                        <span>Въведете или сканирайте серийните номера. Нов ред се добавя автоматично.</span>
                    </div>
                    <div class="wf-brand-chip" [ngClass]="{ 'empty':!returnLockedBrand() }">
                        <span *ngIf="returnLockedBrand()">Марка: <strong>{{ returnLockedBrand() }}</strong></span>
                        <span *ngIf="!returnLockedBrand()">Изберете марка на първия ред</span>
                    </div>
                </div>
                <div class="wf-brand-warning" *ngIf="!returnSingleBrand()">Тази карта съдържа артикули от повече от една марка. Нови артикули могат да бъдат само от марка <strong>{{ returnLockedBrand() }}</strong>.</div>

                <div class="wf-product-table">
                    <div class="wf-product-row wf-product-head">
                        <span>№</span>
                        <span>Марка</span>
                        <span><i class="icon indoor-unit wf-unit-icon"></i>Сериен № (вътр. тяло)</span>
                        <span>Модел (вътр. тяло)</span>
                        <span><i class="icon outdoor-unit wf-unit-icon"></i>Сериен № (външ. тяло)</span>
                        <span>Модел (външ. тяло)</span>
                        <span></span>
                    </div>
                    <div class="wf-product-row" *ngFor="let item of items;let i = index" [ngClass]="{ 'wf-row-empty':i == items.length - 1 }">
                        <span class="wf-row-num">{{ i + 1 }}</span>
                        <select [(ngModel)]="item.brand" (change)="onBrandChange(i)">
                            <option value="{{brand.name}}" [disabled]="returnBrandDisabled(brand.name, i)" *ngFor="let brand of availableBrands">{{ brand.name }}</option>
                        </select>
                        <input type="text" id="serial_internal{{i}}" [(ngModel)]="item.serial_internal" (keyup)="checkForNewRow(i, 'serial_internal')" (focus)="item.selectingInternal = true" (focusout)="deselectItemInternal(i)" placeholder="Сериен №" (keyup.enter)="onDetected($event, 'serial_internal', i)">
                        <input type="text" id="model_internal{{i}}" [(ngModel)]="item.model_internal" (keyup)="checkForNewRow(i, 'model_internal')" placeholder="Модел">
                        <input type="text" id="serial_external{{i}}" [(ngModel)]="item.serial_external" (keyup)="checkForNewRow(i, 'serial_external')" (focus)="item.selectingExternal = true" (focusout)="deselectItemExternal(i)" placeholder="Сериен №" (keyup.enter)="onDetected($event, 'serial_external', i)" />
                        <input type="text" id="model_external{{i}}" [(ngModel)]="item.model_external" (keyup)="checkForNewRow(i, 'model_external')" placeholder="Модел" />
                        <div class="wf-row-action"><div class='action-remove' *ngIf="items.length > 1" (click)="removeItem(i)" title="Премахване на реда"><i class='icon cross'></i></div></div>
                    </div>
                </div>
            </div>

            <div class="tab" *ngIf="tab == 'warranty_text'">
                <div class="wf-section-title">Гаранционни условия</div>
                <div class="list-selection">
                    <div [ngClass]="{ 'active':currentWarrantyText.uid == text.uid }" (click)="currentWarrantyText = text" *ngFor="let text of warranty_text">{{ text.ttl }}</div>
                </div>

                <div class="wf-section-title">Преглед</div>

                <div class="warranty_details" [innerHTML]="decodeHTMLEntities(currentWarrantyText.layout)">
                    
                </div>
            </div>

            <div class="tab" *ngIf="tab == 'warranty_time'">
                <div class="wf-section-title">Гаранционни сроци</div>
                <div class="wf-period-table">
                    <div class="wf-period-row wf-period-head">
                        <span>Марка</span>
                        <span>Срок (месеци)</span>
                    </div>
                    <div class="wf-period-row" *ngFor="let brand of availableBrands;let i = index" [ngClass]="{ 'hide':!returnIsBrandAdded(brand) }">
                        <input type="text" readonly value="{{ brand.name }}" />
                        <input type="text" [(ngModel)]="brand.warranty_period" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
